import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AppUser } from '../types';

interface AuthState {
  user: AppUser | null;
  supabaseUser: any | null;
  isLoading: boolean;
  setUser: (user: AppUser | null, supabaseUser?: any | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      supabaseUser: null,
      isLoading: true,
      setUser: (user, supabaseUser = null) => set({ user, supabaseUser, isLoading: false }),
      logout: () => set({ user: null, supabaseUser: null, isLoading: false }),
    }),
    {
      name: 'mila-auth',
    }
  )
);
